import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../../api/axios';
import SearchSelect from '../../../components/SearchSelect';

// ✨ Ağıllı banket: qiymət + minimum qonaq + minimum mənfəət → son 1 ilin satışı və texkarta
// mayası ilə 5-7 kateqoriyalı banket təklifi. «Başqa variant» yenisini qurur, «✕» məhsulu çıxarıb
// yenidən qurur, «Draft kimi yarat» saxlayır (yalnız admin görür, sonra yoxlayıb Aktiv edirsən).

const LS_KEY = 'banquet_ai_form';
const money = (v) => `${Number(v || 0).toFixed(2)} ₼`;
const fmt = (v) => { const n = Number(v || 0); return Number.isInteger(n) ? String(n) : n.toFixed(2); };

const DEFAULT_FORM = { price: '30', min_guests: '30', min_profit: '17', min_discount: '15', bundle: '6' };
const loadForm = () => {
    try { return { ...DEFAULT_FORM, ...JSON.parse(localStorage.getItem(LS_KEY) || '{}') }; }
    catch { return { ...DEFAULT_FORM }; }
};
const loadMust = () => { try { return JSON.parse(localStorage.getItem(LS_KEY + '_must') || '[]'); } catch { return []; } };

// «Hər N nəfərə neçə ədəd» (masaya qoyulanlar). Porsiyalı məhsullar (şiş, bilinçik) avtomatik:
// hər qonağa ən azı 1 ədəd düşəcək qədər porsiya.
const PER_FIELDS = [
    ['salad', 'Salat'], ['cold', 'Soyuq qəlyanaltı'], ['bread', 'Çörək'], ['drink', 'İçki'],
    ['whole', 'Bütöv isti yemək'], ['side', 'Manqal əlavəsi'], ['dessert', 'Çay'],
];
const DEFAULT_PER = { salad: 1, cold: 1, bread: 2, drink: 1, whole: 1, side: 1, dessert: 1 };

const COUNT_FIELDS = [
    ['kabab', 'Kabab növü (hər qonağa 1 şiş)', 3],
    ['whole', 'Bütöv isti yemək', 3],
    ['salad', 'Salat', 3],
    ['cold', 'Soyuq qəlyanaltı (çörəkdən əlavə)', 5],
    ['drink', 'İçki', 2],
    ['side', 'Manqal əlavəsi', 1],
];

export default function AiBanquetModal({ open, onClose, onCreated }) {
    const [form, setForm] = useState(loadForm);
    const [counts, setCounts] = useState(() => Object.fromEntries(COUNT_FIELDS.map(([k, , d]) => [k, d])));
    const [perBundle, setPerBundle] = useState(DEFAULT_PER);
    const [must, setMust] = useState(loadMust);          // [{id, name}]
    const [pickable, setPickable] = useState([]);
    useEffect(() => {
        if (!open || pickable.length) return;
        api.get('/banquet/pickable').then((r) => setPickable(r.data?.data || [])).catch(() => {});
    }, [open, pickable.length]);
    const saveMust = (list) => { setMust(list); try { localStorage.setItem(LS_KEY + '_must', JSON.stringify(list)); } catch { /* ignore */ } };
    const [showAdv, setShowAdv] = useState(false);
    const [result, setResult] = useState(null);
    const [seed, setSeed] = useState(1);
    const [exclude, setExclude] = useState([]);
    const [busy, setBusy] = useState('');
    const [name, setName] = useState('');

    if (!open) return null;

    const generate = async (nextSeed, prevIds = [], ex = exclude) => {
        const price = Number(form.price), g = parseInt(form.min_guests, 10), mp = Number(form.min_profit);
        if (!(price > 0) || !(g > 0) || !(mp >= 0)) { toast.error('Qiymət, qonaq sayı və mənfəəti yazın.'); return; }
        if (mp >= price) { toast.error('Mənfəət qiymətdən az olmalıdır.'); return; }
        setBusy('gen');
        try { localStorage.setItem(LS_KEY, JSON.stringify(form)); } catch { /* ignore */ }
        try {
            const r = await api.post('/banquet/ai/generate', {
                price, min_guests: g, min_profit: mp, min_discount: Number(form.min_discount) || 0,
                seed: nextSeed, prev_ids: prevIds, exclude_ids: ex, counts,
                must_ids: must.map((m) => m.id), bundle: parseInt(form.bundle, 10) || 6, per_bundle: perBundle,
            }, { timeout: 30000 });
            setResult(r.data?.data || null);
            setSeed(nextSeed);
            if (!name) setName(`Banket menyu ${fmt(price)} ₼`);
        } catch (e) {
            toast.error(e.response?.data?.msg || 'Təklif hazırlanmadı.');
        } finally {
            setBusy('');
        }
    };

    const another = () => generate(seed + 1, result?.item_ids || []);
    const removeOne = (id) => { const ex = [...exclude, id]; setExclude(ex); generate(seed, [], ex); };

    const create = async () => {
        if (!result) return;
        setBusy('create');
        try {
            const r = await api.post('/banquet/ai/create', {
                name: name.trim() || `Banket menyu ${fmt(result.price)} ₼`,
                price: result.price, min_guests: result.min_guests,
                groups: result.groups.map((g) => ({ label: g.label, items: g.items })),
            });
            toast.success('Ağıllı banket draft kimi yaradıldı. Yoxla, bəyənsən statusu «Aktiv» et.');
            onCreated?.(r.data?.id);
            setResult(null); setExclude([]); setSeed(1);
            onClose();
        } catch (e) {
            toast.error(e.response?.data?.msg || 'Yaradılmadı.');
        } finally {
            setBusy('');
        }
    };

    const field = (k, label, suffix) => (
        <div>
            <label className="mb-1.5 block text-xs font-semibold text-gray-600">{label}</label>
            <div className="flex items-center overflow-hidden rounded-xl border border-gray-200 bg-white focus-within:border-primary-400">
                <input type="number" min="0" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                    className="w-full min-w-0 bg-transparent px-3 py-2.5 text-sm font-bold text-gray-800 focus:outline-none" />
                <span className="shrink-0 border-l border-gray-100 bg-gray-50 px-3 py-2.5 text-xs font-semibold text-gray-500">{suffix}</span>
            </div>
        </div>
    );

    return (
        <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/45 p-4 sm:pt-10" onMouseDown={() => !busy && onClose()}>
            <div className="w-full max-w-3xl rounded-2xl bg-white shadow-2xl" onMouseDown={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
                    <div>
                        <div className="text-lg font-black text-gray-800">✨ Ağıllı banket yarat</div>
                        <div className="text-xs text-gray-400">Son 1 ilin ən çox satılanları və texkarta mayası ilə</div>
                    </div>
                    <button onClick={onClose} className="rounded-lg px-2 py-1 text-xl text-gray-400 hover:bg-gray-100">×</button>
                </div>

                <div className="space-y-4 p-5">
                    {/* Şərtlər */}
                    <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
                        {field('price', 'Qiymət', '₼/nəfər')}
                        {field('min_guests', 'Minimum qonaq', 'nəfər')}
                        {field('min_profit', 'Minimum mənfəət', '₼/nəfər')}
                        {field('min_discount', 'Qonağa endirim', '% min')}
                        {field('bundle', 'Paket', 'nəfərə')}
                    </div>
                    <p className="-mt-2 text-[11px] text-gray-400">
                        Hər şey «hər {parseInt(form.bundle, 10) || 6} nəfərə» hesablanır. Porsiyalı məhsullar (şiş, bilinçik) porsiya ilə yazılır, hər qonağa ən azı 1 ədəd düşür.
                    </p>

                    {/* Mütləq olsun */}
                    <div className="rounded-xl border border-emerald-100 bg-emerald-50/40 p-3">
                        <div className="mb-1.5 text-xs font-bold text-emerald-800">📌 Mütləq olsun</div>
                        <SearchSelect
                            value=""
                            placeholder="Məhsul axtar və əlavə et (hər variantda menyuda qalacaq)..."
                            options={pickable.map((pi) => ({ value: pi.id, label: `${pi.name} · ${pi.category_name}`, disabled: must.some((m) => m.id === pi.id) }))}
                            onChange={(id) => {
                                const pi = pickable.find((p) => String(p.id) === String(id));
                                if (pi && !must.some((m) => m.id === pi.id)) saveMust([...must, { id: pi.id, name: pi.name }]);
                            }}
                        />
                        {must.length > 0 && (
                            <div className="mt-2 flex flex-wrap gap-1.5">
                                {must.map((m) => (
                                    <span key={m.id} className="flex items-center gap-1 rounded-full bg-white py-1 pl-3 pr-1 text-xs font-semibold text-emerald-800 ring-1 ring-emerald-200">
                                        {m.name}
                                        <button type="button" onClick={() => saveMust(must.filter((x) => x.id !== m.id))}
                                            className="flex h-5 w-5 items-center justify-center rounded-full text-emerald-500 hover:bg-emerald-100">✕</button>
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>

                    <button type="button" onClick={() => setShowAdv(!showAdv)} className="text-xs font-semibold text-primary-700 hover:underline">
                        {showAdv ? '▲ Kateqoriya saylarını gizlət' : '▼ Kateqoriya sayları'}
                    </button>
                    {showAdv && (
                        <div className="space-y-3 rounded-xl border border-gray-100 bg-gray-50 p-3">
                            <div>
                                <div className="mb-1.5 text-[11px] font-bold uppercase tracking-wider text-gray-500">Neçə növ</div>
                                <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
                                    {COUNT_FIELDS.map(([k, label]) => (
                                        <label key={k} className="flex items-center justify-between gap-2 text-xs text-gray-600">
                                            <span>{label}</span>
                                            <input type="number" min="0" max="10" value={counts[k]}
                                                onChange={(e) => setCounts({ ...counts, [k]: Math.max(0, Math.min(10, parseInt(e.target.value, 10) || 0)) })}
                                                className="w-14 rounded-lg border border-gray-200 px-2 py-1 text-center text-sm font-bold" />
                                        </label>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <div className="mb-1.5 text-[11px] font-bold uppercase tracking-wider text-gray-500">Hər {parseInt(form.bundle, 10) || 6} nəfərə neçə ədəd</div>
                                <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
                                    {PER_FIELDS.map(([k, label]) => (
                                        <label key={k} className="flex items-center justify-between gap-2 text-xs text-gray-600">
                                            <span>{label}</span>
                                            <input type="number" min="1" max="10" value={perBundle[k]}
                                                onChange={(e) => setPerBundle({ ...perBundle, [k]: Math.max(1, Math.min(10, parseInt(e.target.value, 10) || 1)) })}
                                                className="w-14 rounded-lg border border-gray-200 px-2 py-1 text-center text-sm font-bold" />
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {!result && (
                        <button onClick={() => generate(1)} disabled={!!busy}
                            className="w-full rounded-xl bg-primary-600 py-3 text-sm font-black text-white hover:bg-primary-700 disabled:opacity-50">
                            {busy === 'gen' ? 'Hazırlanır...' : '✨ Təklif hazırla'}
                        </button>
                    )}

                    {/* Nəticə */}
                    {result && (
                        <div className="space-y-3">
                            <div className={`grid grid-cols-2 gap-2 rounded-xl border p-3 sm:grid-cols-4 ${result.ok ? 'border-emerald-200 bg-emerald-50/50' : 'border-amber-200 bg-amber-50'}`}>
                                <Stat label="Mənfəət / nəfər" value={money(result.profit_pp)} strong={result.ok ? 'text-emerald-700' : 'text-amber-700'} />
                                <Stat label="Maya / nəfər" value={money(result.cost_pp)} />
                                <Stat label="Menyu dəyəri / nəfər" value={money(result.menu_value_pp)} />
                                <Stat label="Qonağın endirimi" value={`${result.discount_pct}%`} />
                            </div>
                            {!result.ok && (
                                <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800">
                                    ⚠️ Bu qiymətlə hədəf mənfəətə çatmaq olmadı. Qiyməti qaldır, mənfəəti azalt və ya kateqoriya saylarını azalt.
                                </div>
                            )}

                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                {result.groups.map((g) => (
                                    <div key={g.key} className="rounded-xl border border-gray-200 p-3">
                                        <div className="mb-1.5 text-[11px] font-black uppercase tracking-wider text-primary-700">{g.label}</div>
                                        {g.items.map((it) => (
                                            <div key={it.menu_item_id} className="group flex items-center gap-2 py-0.5 text-sm">
                                                <span className="min-w-0 flex-1 truncate text-gray-800">{it.name}</span>
                                                <span className="shrink-0 text-[11px] text-gray-400">
                                                    {`${fmt(it.qty)} ${it.qty_unit === 'portion' ? 'pors' : 'əd'} / ${it.guests_per_bundle} nəf`}
                                                </span>
                                                <span className="w-14 shrink-0 text-right text-[11px] font-semibold text-amber-700">{fmt(it.cost_pp)} ₼</span>
                                                <button type="button" onClick={() => removeOne(it.menu_item_id)} disabled={!!busy}
                                                    title="Bunu istəmirəm (çıxar və yenidən qur)"
                                                    className="shrink-0 rounded px-1 text-gray-300 hover:bg-red-50 hover:text-red-500">✕</button>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                            <p className="text-[11px] text-gray-400">Sağdakı rəqəm məhsulun 1 nəfərə düşən mayasıdır. «✕» məhsulu çıxarıb menyunu yenidən qurur.</p>

                            {result.suspicious?.length > 0 && (
                                <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-[11px] text-red-700">
                                    ⚠️ Texkartası şübhəli olduğu üçün seçilmədi (mayası çox aşağı görünür): {result.suspicious.join(', ')}. Texkartalarını yoxla.
                                </div>
                            )}

                            <div className="flex flex-wrap items-end gap-2 border-t border-gray-100 pt-3">
                                <div className="min-w-[200px] flex-1">
                                    <label className="mb-1.5 block text-xs font-semibold text-gray-600">Banketin adı</label>
                                    <input value={name} onChange={(e) => setName(e.target.value)}
                                        className="w-full rounded-xl border border-gray-200 px-3 py-2.5 text-sm font-semibold focus:border-primary-400 focus:outline-none" />
                                </div>
                                <button onClick={another} disabled={!!busy}
                                    className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-bold text-gray-700 hover:bg-gray-50 disabled:opacity-50">
                                    {busy === 'gen' ? '...' : '🔄 Başqa variant'}
                                </button>
                                <button onClick={create} disabled={!!busy || !result.groups.length}
                                    className="rounded-xl bg-primary-600 px-5 py-2.5 text-sm font-black text-white hover:bg-primary-700 disabled:opacity-50">
                                    {busy === 'create' ? 'Yaradılır...' : '✓ Draft kimi yarat'}
                                </button>
                            </div>
                            {exclude.length > 0 && (
                                <button type="button" onClick={() => { setExclude([]); generate(seed, [], []); }}
                                    className="text-[11px] font-semibold text-gray-400 hover:text-gray-600">↺ Çıxarılan {exclude.length} məhsulu geri qaytar</button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

function Stat({ label, value, strong = 'text-gray-800' }) {
    return (
        <div className="text-center">
            <div className="text-[11px] text-gray-500">{label}</div>
            <div className={`text-base font-black ${strong}`}>{value}</div>
        </div>
    );
}
